import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'
import { FC } from 'react'

import style from '@src/components/SliderSwiper/SliderSwiper.module.scss'

type SliderSwiperData = {
  data: Array<{
    id: number
    title: string
    link: string
    image: string
  }>
}
const moveObjectWithHashLinkToBeginning = (data: SliderSwiperData['data']) => {
  const dataCopy = [...data]
  const objectWithHashLink = dataCopy.find((item) => item.link.includes('#'))

  if (objectWithHashLink) {
    dataCopy.splice(dataCopy.indexOf(objectWithHashLink), 1)
    dataCopy.unshift(objectWithHashLink)
  }

  return dataCopy
}
const constructLink = (slide: SliderSwiperData['data'][0]) => {
  const linkWithoutHash = slide.link.replace('#', '')
  if (slide.link.includes('#')) {
    return `${process.env.REACT_APP_API_URL}/${linkWithoutHash}`
  }
  return `${process.env.REACT_APP_SITE_URL}/clients/promotions/${slide.link}`
}
export const SliderSwiper: FC<SliderSwiperData> = ({ data }) => {
  const updatedData = moveObjectWithHashLinkToBeginning(data)

  return (
    <Swiper
      spaceBetween={22}
      slidesPerView="auto"
            // loop
            // loopedSlides={2}
      breakpoints={{
        500: {
          spaceBetween: 15,
        },
      }}
      className={style.items}
      navigation
    >
      {updatedData.map((slide) => (
        <SwiperSlide key={slide.id} className={style.slideSize}>
          <div className={style.item}>
            <a href={constructLink(slide)}>
              <img src={`${process.env.REACT_APP_SITE_URL}${slide.image}`} alt={slide.title} />
              <div>{slide.title}</div>
            </a>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  )
}
